import React from "react"
import styled, { css } from "styled-components"
import TickIcon from "../../../../images/icons/tick.inline.svg"
import { ErrorMessage } from "../../general-styles.component"
import CheckboxProps from "./checkbox.interface"
import { uniqueId } from "lodash"
import { AppFunctionComponent } from "../../../../types"

const CheckboxWrapper = styled.label`
  display: flex;
  flex-direction: row;
`

const Tick = styled(TickIcon)`
  width: 11px;
  height: 20px;
  display: block;

  opacity: 0;
  visibility: hidden;

  transition: all 0.15s ease-in-out;

  color: ${({ theme }) => theme.color.textInverted};
`

const CustomCheckbox = styled.div<{ error?: boolean }>`
  display: flex;
  position: relative;
  width: 20px;
  min-width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 0.4rem;
  box-sizing: border-box;

  flex-direction: row;
  align-items: center;
  justify-content: center;

  border-radius: ${({ theme }) => theme.size.borderRadiusSmall};
  border: 1px solid ${({ theme }) => theme.color.commerceBorder};

  ${({ error }) =>
    error &&
    css`
      border: 1px solid ${({ theme }) => theme.color.error};
    `}

  cursor: pointer;

  transition: all 0.15s ease-in-out;
`

const CheckboxInput = styled.input`
  width: 0;
  opacity: 0;

  &:focus {
    + ${CustomCheckbox} {
      border-color: ${({ theme }) => theme.color.commerceBlue};
    }
  }
  &:checked {
    + ${CustomCheckbox} {
      background-color: ${({ theme }) => theme.color.commerceBlue};
      border-color: ${({ theme }) => theme.color.commerceBlue};
      ${Tick} {
        opacity: 1;
        visibility: visible;
      }
    }
  }
`

export const checkboxLabelStyles = css`
  font-size: 1rem;
  padding-top: 1px;
  font-weight: 300;
  line-height: 2em;
  font-family: ${({ theme }) => theme.font.basic};

  cursor: pointer;
`

const CustomLabel = styled.span`
  display: flex;
  align-items: center;
  flex-direction: row;

  ${checkboxLabelStyles};
`

const Checkbox: AppFunctionComponent<CheckboxProps> = ({
  className,
  children,
  label,
  checkboxRef,
  error,
  ...props
}) => {
  const errorId = `id-${uniqueId()}-error`
  return (
    <>
      <CheckboxWrapper className={className}>
        <CheckboxInput
          type="checkbox"
          {...props}
          ref={checkboxRef}
          aria-describedby={errorId}
        />
        <CustomCheckbox error={Boolean(error)}>
          <Tick aria-hidden="true" />
        </CustomCheckbox>
        {label && Boolean(label.length) ? (
          <CustomLabel>{label}</CustomLabel>
        ) : (
          children
        )}
      </CheckboxWrapper>
      {error && <ErrorMessage id={errorId}>{error}</ErrorMessage>}
    </>
  )
}

export default Checkbox
